import { Stack } from '@mui/material'
import yesIcon from 'images/icons/yes.svg'
import sosoIcon from 'images/icons/soso.svg'
import noIcon from 'images/icons/no.svg'
import naIcon from 'images/icons/na.svg'
import { AnswerDictType, AnswerLabelType } from './answer-label-types'
import { AnswerLegendText } from './answer-label-styles'

const answerDict: AnswerDictType = {
  yes: { alt: 'Ícone de resposta sim', icon: yesIcon, label: 'SIM' },
  soso: { alt: 'Ícone de resposta talvez', icon: sosoIcon, label: 'TALVEZ' },
  no: { alt: 'Ícone de resposta não', icon: noIcon, label: 'NÃO' },
  NA: { alt: 'Ícone de sem info', icon: naIcon, label: 'SEM INFO' },
}

const AnswerLabel = ({ answer, qtd }: AnswerLabelType) => {
  const { alt, icon, label } = answerDict[answer]

  return (
    <Stack direction={'row'} alignItems='center' spacing='4px'>
      <img src={icon} height='12px' alt={alt} />
      <AnswerLegendText>
        {qtd} {label}
      </AnswerLegendText>
    </Stack>
  )
}

export default AnswerLabel
